import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import createApolloClient from './clients/create-apollo-client';
import { GlobalContextProvider } from './context/globalContext';
import { isMobile } from './utils';
import ErrorHandler from './clients/error-handler';
import { ResourceItemContextProvider } from 'context/resourceItemContext';

function MerakMall({ default: App, Toast: toaster }) {
    const errroHandler = new ErrorHandler({ toaster });
    const apolloClient = createApolloClient(errroHandler);
    ReactDOM.render(
        <ApolloProvider client={apolloClient}>
            <GlobalContextProvider errorHandler={errroHandler}>
                <ResourceItemContextProvider>
                    <App />
                </ResourceItemContextProvider>
            </GlobalContextProvider>
        </ApolloProvider>,
        document.getElementById('root'),
    );
}

if (isMobile()) {
    import('./mobile/app').then(MerakMall);
} else {
    import('./pc/app').then(MerakMall);
}
